export enum QuotationStatus {
    DRAFT =0,
    OFFER = 2,
    LEAD = 6,
    ORDERED = 3
}